import { render, staticRenderFns } from "./CombatResults.vue?vue&type=template&id=6e0af370&"
import script from "./CombatResults.vue?vue&type=script&lang=js&"
export * from "./CombatResults.vue?vue&type=script&lang=js&"
import style0 from "./CombatResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports